/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEmailMessage,
    JsonEmailMessageFromJSON,
    JsonEmailMessageFromJSONTyped,
    JsonEmailMessageToJSON,
} from './JsonEmailMessage';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEmailMessage
 */
export interface ApiResultOfJsonEmailMessage {
    /**
     * 
     * @type {JsonEmailMessage}
     * @memberof ApiResultOfJsonEmailMessage
     */
    data?: JsonEmailMessage;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEmailMessage
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEmailMessage
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEmailMessage
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEmailMessage
     */
    result?: ApiResultOfJsonEmailMessageResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEmailMessageResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEmailMessageFromJSON(json: any): ApiResultOfJsonEmailMessage {
    return ApiResultOfJsonEmailMessageFromJSONTyped(json, false);
}

export function ApiResultOfJsonEmailMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEmailMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEmailMessageFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEmailMessageToJSON(value?: ApiResultOfJsonEmailMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEmailMessageToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

